// extracted by mini-css-extract-plugin
module.exports = {"fixedBinTable":"styles_fixedBinTable__3hUtg","buttons":"styles_buttons__3zxFJ"};